import React from 'react';

import CheckmarkIcon from '@/assets/checkmark.svg?react';
import { UiTypography } from '@/components/ui/Typography';

import { WHAT_YOU_GET_DISCRIPTION } from './constant';
import './WhatYouGet.scss';

export const OnboardingPaywallWhatYouGet: React.FC = () => {
  return (
    <section className="onboarding-paywall-what-you-get">
      <div className="onboarding-paywall-what-you-get__wrapper">
        <div className="onboarding-paywall-what-you-get__header">
          <div className="onboarding-paywall-what-you-get__header-label">
            <svg
              width="12"
              height="16"
              viewBox="0 0 12 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.08807 15.4991C4.0043 15.4991 3.92152 15.4809 3.84557 15.4455C3.76961 15.4102 3.70231 15.3587 3.64841 15.2945C3.5945 15.2304 3.55528 15.1553 3.53352 15.0744C3.51176 14.9935 3.50798 14.9088 3.52245 14.8263V14.8228L4.40088 9.99907H0.999947C0.905547 9.99906 0.813078 9.97232 0.733237 9.92196C0.653395 9.8716 0.589442 9.79966 0.548775 9.71447C0.508108 9.62927 0.492389 9.53431 0.503435 9.44056C0.514482 9.34681 0.551843 9.2581 0.611196 9.18469L7.46026 0.717818C7.53822 0.618857 7.64645 0.548153 7.76839 0.51652C7.89034 0.484886 8.01928 0.494063 8.13552 0.542648C8.25175 0.591233 8.34888 0.676551 8.41204 0.785556C8.47519 0.89456 8.50091 1.02125 8.48526 1.14626C8.48526 1.15563 8.48276 1.16469 8.4812 1.17407L7.59963 5.99907H10.9999C11.0943 5.99908 11.1868 6.02581 11.2667 6.07618C11.3465 6.12654 11.4105 6.19848 11.4511 6.28367C11.4918 6.36886 11.5075 6.46383 11.4965 6.55758C11.4854 6.65133 11.4481 6.74004 11.3887 6.81344L4.5387 15.2803C4.48487 15.3483 4.4164 15.4033 4.33838 15.4412C4.26036 15.4791 4.1748 15.4988 4.08807 15.4991Z"
                fill="white"
              />
            </svg>

            <UiTypography variant="body-small" color="white">
              Best for you
            </UiTypography>
          </div>
          <UiTypography
            variant="title-large"
            className="onboarding-paywall-what-you-get__header-title"
            color="white"
          >
            What You Get
          </UiTypography>
        </div>

        <div className="onboarding-paywall-what-you-get__content">
          {WHAT_YOU_GET_DISCRIPTION.map((item) => (
            <div
              key={item.title}
              className="onboarding-paywall-what-you-get__content-item"
            >
              <div className="onboarding-paywall-what-you-get__content-item-icon">
                <CheckmarkIcon />
              </div>
              <div>
                <UiTypography variant="title-small">{item.title}</UiTypography>
                <UiTypography variant="body-small" color="neutral-black">
                  {item.description}
                </UiTypography>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
